import { WizardStepModel } from '../models/wizard/wizard-step.model';
import { WizardStepStylingModel } from '../models/wizard/wizard-step-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';

export const /** @type {?} */ WizardStepTemplates = {
  defaultTemplate: {
    property: new WizardStepModel({
      label: 'Step',
      isValid: true,
      display: true,
      disable: false
    }),
    style: new WizardStepStylingModel()
  }
}
